import { formToolbarActionRegistry } from 'sulu-admin-bundle/views';
import NewsNotificationToolbarAction from "./toolbar-actions/form/NewsNotificationToolbarAction";
import 'sulu-massive-short-url-bundle';
import 'sulu-massive-custom-translation-bundle';

formToolbarActionRegistry.add('app.news_notification', NewsNotificationToolbarAction);
